module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "in-infos"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("发票信息")]), _vm._v(" "), _c('ul', {
    staticClass: "infos"
  }, [_c('li', [_c('label', {
    staticClass: "name"
  }, [_vm._v("抬头类型：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.titleTypeStr || '空'))])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "name"
  }, [_vm._v("发票抬头：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.title || '空'))])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "name"
  }, [_vm._v("纳税识别号：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.taxpayerNo || '空'))])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "name"
  }, [_vm._v("注册电话：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.registeredPhone || '空'))])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "name"
  }, [_vm._v("开票地址：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.invoiceAddress || '空'))])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "name"
  }, [_vm._v("开户行：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.bank || '空'))])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "name"
  }, [_vm._v("开户账号：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.invoice.account || '空'))])])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.editInvoice
    }
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("编辑信息")])]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("寄送地址")]), _vm._v(" "), _c('ul', {
    staticClass: "address"
  }, _vm._l((_vm.express), function(item) {
    return _c('li', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "group"
    }, [_c('label', {
      staticClass: "name"
    }, [_vm._v("地址名称")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "group"
    }, [_c('label', {
      staticClass: "name"
    }, [_vm._v("联系人")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.contact))])]), _vm._v(" "), _c('div', {
      staticClass: "group"
    }, [_c('label', {
      staticClass: "name"
    }, [_vm._v("联系电话")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.phone))])]), _vm._v(" "), _c('div', {
      staticClass: "group"
    }, [_c('label', {
      staticClass: "name"
    }, [_vm._v("详细地址")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.address))])]), _vm._v(" "), _c('div', {
      staticClass: "group"
    }, [_c('label', {
      staticClass: "name"
    }, [_vm._v("邮政编码")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.zipCode))])]), _vm._v(" "), _c('div', {
      staticClass: "options"
    }, [(!item.isDefault) ? _c('a', {
      staticClass: "link",
      on: {
        "click": function($event) {
          _vm.setDefault(item.id)
        }
      }
    }, [_vm._v("设为默认")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "link",
      on: {
        "click": function($event) {
          _vm.editExpress(item.id)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('a', {
      staticClass: "link red",
      on: {
        "click": function($event) {
          _vm.delHandle(item.id, item.name)
        }
      }
    }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isDefault),
        expression: "item.isDefault"
      }],
      staticClass: "default"
    }, [_vm._v("\n          默认\n        ")])])
  })), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.editExpress()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("新建地址")])]), _vm._v(" "), (_vm.addnewShow) ? _c('add-new', {
    ref: "addNew",
    attrs: {
      "modal": false,
      "addnewProp": _vm.addnewProp
    },
    on: {
      "refresh": _vm.getList,
      "closeForDetail": function($event) {
        _vm.addnewShow = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34fba974","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/invoice-detail.vue
// module id = 1249
// module chunks = 82